import moment from 'moment'

import {truncateText} from '../utils/truncateText'

interface KilnShellMaterialTitleProps {
  x: number
  refractoryName?: string
  kilnHeight: number
  materialWidth: number
  feedingDate?: string
  textColor?: string
}

export const KilnShellMaterialTitle: React.FC<KilnShellMaterialTitleProps> = ({
  x,
  refractoryName,
  kilnHeight,
  materialWidth,
  feedingDate,
  textColor = 'white'
}) => {
  return (
    <g>
      <text
        x={x}
        y={kilnHeight / 2 - 10}
        width={materialWidth}
        textAnchor="middle"
        dominantBaseline="middle"
        fill={textColor}
      >
        {truncateText(
          feedingDate !== '' ? moment(feedingDate).format('MM/YYYY') : '',
          materialWidth / 12
        )}
      </text>
      <text
        x={x}
        y={kilnHeight / 2 + 5}
        dominantBaseline="middle"
        textAnchor="middle"
        fill={textColor}
      >
        {truncateText(refractoryName ?? '', materialWidth / 12)}
      </text>
    </g>
  )
}
